import { SESSION_STORAGE_SHOW_NOTIFY_ME_WARNING_KEY } from "./constants";

export const sessionHasNotifyMeWarningStored = () => {
  let showNotifyMeWarning;

  try {
    showNotifyMeWarning = sessionStorage.getItem(
      SESSION_STORAGE_SHOW_NOTIFY_ME_WARNING_KEY
    );
    // eslint-disable-next-line no-empty
  } catch (_) {}

  return showNotifyMeWarning === "true";
};
